$(document).on("click", "#sign-out, #sign-out-mobile", function(e){
  e.preventDefault()
  $.ajax({
    url: "/users/sign_out",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    method: "delete",
    success: () => { window.location.reload() },
    error: () => { alert('Logout gagal') }
  })
})
